import React from 'react';
import styled, { css } from 'styled-components';
import { useRouter } from 'next/router';

import share, { SocialType } from '@/utils/share';
import TelegramIcon from '@/assets/svg/socials/tlgrm.svg';
import ViberIcon from '@/assets/svg/socials/viber.svg';
import { media } from '@/utils/mixin';
import { colors } from '@/constants/theme';

function SocialsList() {
  const router = useRouter();

  function handleSocialShare(type: SocialType) {
    return () => {
      share(type, router.asPath);
    };
  }

  return (
    <Component>
      <Title>Поделиться в соц. сетях:</Title>
      <List>
        <Social onClick={handleSocialShare('tg')}>
          <TelegramIcon />
        </Social>
        <Social onClick={handleSocialShare('viber')}>
          <ViberIcon />
        </Social>
      </List>
    </Component>
  );
}

export default SocialsList;

const Component = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 20px;

  ${media.tablet(css`
    margin: 20px 0 0;
    justify-content: flex-start;
  `)}
`;

const Title = styled.p`
  font-size: 16px;
  line-height: 21px;
  opacity: 0.5;
  color: ${colors.black};
`;

const List = styled.div`
  display: flex;
  margin-left: 20px;
`;

const Social = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 25px;
  width: 25px;
  height: 25px;
  transition: 0.3s;

  svg {
    width: 100%;
    height: 100%;

    path {
      fill: ${colors.black};
    }
  }

  &:hover {
    opacity: 0.6;
  }

  &:not(:first-child) {
    margin-left: 20px;
  }
`;
